import React from 'react'
import { Plus, Minus } from '@/components/svg'
import ButtonBase from '../ButtonBase'
import { useAccordionContext } from './AccordionContext'

export interface Props {
  index: number
  children: React.ReactNode
  className?: string
}

const AccordionSummary: React.FC<Props> = ({ index, children, className }) => {
  const { expanded, setExpanded } = useAccordionContext()
  const isExpanded = expanded === index
  const ToggleIcon = isExpanded ? Minus : Plus

  return (
    <ButtonBase
      className={className}
      onClick={() => setExpanded(isExpanded ? -1 : index)}
    >
      <div className="flex items-center">
        <div className="pr-4 text-left">{children}</div>
        <ToggleIcon className="ml-auto h-4 w-4 shrink-0 sm:h-5 sm:w-5" />
      </div>
    </ButtonBase>
  )
}

export default AccordionSummary
